function RunningIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.3809 6.57534C18.8916 6.78562 19.1351 7.37008 18.9248 7.88077L14.7544 18.0089L16.7452 19.1871L22.7058 11.3926C23.0413 10.9539 23.6689 10.8702 24.1076 11.2057C24.5463 11.5411 24.63 12.1688 24.2945 12.6075L18.4285 20.2783L20.473 21.7072C20.7091 21.8722 20.8626 22.1311 20.8941 22.4174L21.8275 30.8905C21.8879 31.4395 21.4919 31.9335 20.943 31.994C20.394 32.0545 19.9 31.6585 19.8395 31.1095L18.9558 23.0869L16.4583 21.3413L12.9908 19.2892C12.5632 19.0361 12.3863 18.5073 12.5755 18.0478L17.0755 7.11927C17.2857 6.60858 17.8702 6.36506 18.3809 6.57534Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.4454 5.16795C12.6888 5.00572 12.9909 4.95815 13.2724 5.03778L22.4609 7.63778C22.7339 7.71503 22.9612 7.90459 23.0862 8.15925L26.7391 15.5985L30.9994 13.1344C31.4775 12.8579 32.0892 13.0213 32.3657 13.4993C32.6423 13.9774 32.4789 14.5891 32.0008 14.8656L26.8139 17.8656C26.5741 18.0043 26.2875 18.0373 26.0225 17.9568C25.7574 17.8763 25.5377 17.6894 25.4156 17.4408L21.4874 9.44086L13.1713 7.08771L9.05481 9.83206C8.59528 10.1384 7.97441 10.0142 7.66806 9.55471C7.3617 9.09518 7.48588 8.47431 7.94541 8.16795L12.4454 5.16795Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.169 17.7567C14.5795 18.1262 14.6128 18.7585 14.2433 19.169L9.41831 24.5301L1.43352 23.9978C0.882457 23.9611 0.465515 23.4846 0.502253 22.9335C0.53899 22.3824 1.0155 21.9655 1.56656 22.0022L8.58177 22.4699L12.7567 17.831C13.1262 17.4205 13.7585 17.3873 14.169 17.7567Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M25.5 6C26.6046 6 27.5 5.10457 27.5 4C27.5 2.89543 26.6046 2 25.5 2C24.3954 2 23.5 2.89543 23.5 4C23.5 5.10457 24.3954 6 25.5 6ZM25.5 8C27.7091 8 29.5 6.20914 29.5 4C29.5 1.79086 27.7091 0 25.5 0C23.2909 0 21.5 1.79086 21.5 4C21.5 6.20914 23.2909 8 25.5 8Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default RunningIcon;
